export default __webpack_public_path__ + "static/media/update_calc.a40dbcb5.png";